import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import { useParams } from 'react-router-dom'
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { useFileReader } from 'hooks/useFileReader'
import { Dropdown } from 'primereact/dropdown'
import { InputTextarea } from 'primereact/inputtextarea'
import moment from 'moment/moment'
import { Calendar } from 'primereact/calendar'
import icons from 'assets/icons'

const LeadManagementEventModalContent = ({ handleClose, handleAdd, entityId }) => {
    const { leadManagementId } = useParams()
    const [request, loading] = useRequest()
    const { showToast } = useToast()
    const [entityData, setEntityData] = useState({
        leadManagementId: leadManagementId,
        leadManagementEventTypeId: null,
        eventDate: null,
        description: null
    })
    const [eventTypes, setEventTypes] = useState([])
    const [fileData, setFileData, convert] = useFileReader()
    const calendarRef = useRef()

    useEffect(() => {
        request(`/LeadManagement/GetLeadManagementEventTypes`).then((res) => {
            if (res.data.ok) {
                setEventTypes(res.data.result.filter((item) => !item.isSystemEvent).map((item) => ({ label: item.name, value: item.id })))
            }
        })
    }, [])

    useEffect(() => {
        getEntity()
    }, [entityId])

    const getEntity = () => {
        let id = entityData.id || entityId
        if (!id) return

        request(`/LeadManagement/GetLeadManagementEventById`, { params: { id: id } }).then((res) => {
            if (res.data.ok) {
                if (res.data.result.attachmentData) {
                    setFileData([
                        {
                            fileName: res.data.result.attachmentFileName,
                            file: base64ToFile(res.data.result.attachmentData, res.data.result.attachmentFileName, res.data.result.attachmentContentType)
                        }
                    ])
                    res.data.result.attachmentData = null
                    res.data.result.attachmentFileName = null
                    res.data.result.attachmentContentType = null
                }
                setEntityData(res.data.result)
            }
        })
    }

    const handleChange = (e, name) => {
        if (name) {
            setEntityData((prev) => ({ ...prev, [name]: e }))
        } else {
            setEntityData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        }
    }

    const handleSubmit = () => {
        if (!entityData.leadManagementEventTypeId) {
            showToast('Lütfen etkinlik tipi seçiniz', 'error')
            return
        }

        if (!entityData.eventDate) {
            showToast('Lütfen etkinlik tarihi giriniz', 'error')
            return
        }

        if (!entityData.description) {
            showToast('Lütfen etkinlik notu giriniz', 'error')
            return
        }

        const formData = new FormData()
        for (let key in entityData) {
            let value = entityData[key]
            if (value === null || value === undefined) continue
            if (key === 'eventDate') {
                value = moment(value).add(3, 'hours').toISOString()
            }
            formData.append(key.charAt(0).toUpperCase() + key.slice(1), value)
        }
        if (fileData.length) {
            formData.append('attachment', fileData[0].file)
        }

        request('/LeadManagement/UpsertLeadManagementEvent', {
            method: 'PUT',
            data: formData
        }).then((res) => {
            if (res.data.ok) {
                if (entityId) {
                    showToast('Etkinlik güncellendi', 'success')
                } else {
                    showToast('Etkinlik eklendi', 'success')
                }
                handleClose()
                handleAdd()
            } else {
                showToast(res.data?.metadata?.message || 'İşlem sırasında bir hata oluştu', 'error')
            }
        })
    }

    const handleFiles = (files) => {
        setFileData([])
        convert(files)
    }

    const deleteFile = (i) => {
        setFileData((prev) => prev.filter((_, index) => index !== i))
    }

    const base64ToFile = (base64String, fileName, mimeType) => {
        const binaryString = window.atob(base64String)
        const len = binaryString.length
        const bytes = new Uint8Array(len)
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i)
        }
        return new File([bytes], fileName, { type: mimeType })
    }

    return (
        <>
            <div ref={calendarRef} style={{ position: 'absolute', zIndex: 1102, width: 'calc(100% - 4rem)', top: '0', left: '2rem', padding: '2px', overflowX: 'auto', maxHeight: '90vh' }} />
            <div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='text-bold'>Etkinlik Tipi</label>
                            <Dropdown
                                value={entityData.leadManagementEventTypeId}
                                onChange={(e) => handleChange(e.value, 'leadManagementEventTypeId')}
                                options={eventTypes}
                                optionLabel='label'
                                optionValue='value'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='text-bold'>Etkinlik Notu</label>
                            <InputTextarea
                                value={entityData.description}
                                name='description'
                                onChange={handleChange}
                                autoResize={false}
                                style={{ width: '100%', height: '140px', overflowY: 'auto' }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='text-bold'>Etkinlik Tarihi</label>
                            <Calendar
                                value={entityData.eventDate && moment(entityData.eventDate)._d}
                                locale={'tr'}
                                className={'w-100'}
                                dateFormat='dd.mm.yy'
                                showTime
                                hourFormat='24'
                                placeholder='Etkinlik Tarihi'
                                name='eventDate'
                                showButtonBar
                                hideOnDateTimeSelect
                                panelStyle={{ position: 'static' }}
                                appendTo={calendarRef.current}
                                onChange={(e) => handleChange(moment(e.target.value).toISOString(), e.target.name)}
                            />
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <label className='filterTask-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
                            <span className='filterTask-file-upload--form--row--item--file-uploader--label--text'>Dosya eki yüklemek için tıklayınız</span>
                        </label>
                        <input
                            type='file'
                            name='file'
                            onClick={(e) => e.target.value = null}
                            onChange={(e) => handleFiles(e.target.files)}
                            id='file-uploader'
                            className='filterTask-file-upload--form--row--item--file-uploader--input'
                        />
                        {fileData?.length > 0 &&
                            <div className='ml-4 w-100 mt-2 gap-3'>
                                {fileData?.map((file, i) => (
                                    <div className='text-sm comment-fileList w-unset' key={i}>
                                        <div className='d-flex align-items-center'>{file?.fileName}</div>
                                        <icons.delete onClick={() => deleteFile(i)} size={21} className='comment-fileList-delete' />
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                </div>

                <div className='row justify-content-center'>
                    <div className='col-md-3'>
                        <Button
                            handleClick={handleSubmit}
                            className='btn-success w-100 justify-content-center'
                            title={'Kaydet'}
                            disabled={loading}
                        />
                    </div>
                    <div className='col-md-3'>
                        <Button
                            handleClick={handleClose}
                            className='btn-danger-outline w-100 justify-content-center'
                            title={'Vazgeç'}
                            disabled={loading}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

LeadManagementEventModalContent.propTypes = {
    handleClose: PropTypes.func,
    handleAdd: PropTypes.func,
    entityId: PropTypes.number
}

export default LeadManagementEventModalContent
